import { actionTypes } from 'redux-resource';
import * as api from '../api';

export const fetchAllQuickServiceCodes = () => (dispatch) => {
  const actionDefaults = {
    resourceType: 'quickServiceCodes',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchAllQuickServiceCodes()
    .then((response) => {
      let resources = [];

      if (response.data && Array.isArray(response.data)) {
        resources = response.data.map((code) => ({ id: code }));
      }

      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const fetchQuickVendorServiceCodes = (vendor) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'quickServiceCodes',
    requestKey: 'fetchQuickVendorServiceCodes',
    list: `fetchQuickVendorServiceCodes_${vendor}`,
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchQuickVendorServiceCodes(vendor)
    .then((response) => {
      let resources = [];

      if (
        response?.data?.service_codes &&
        Array.isArray(response.data?.service_codes)
      ) {
        resources = response.data.service_codes.map((code) => ({ id: code }));
      }

      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};
